import React, { useEffect, useState } from "react";
import { statecityData } from "../../../shared/enums";
import GlobalButton from "../../../shared/utils/GlobalButton";
import Styles from "../../../styles/vendorDashboard.module.css";
import CheckIcon from "@mui/icons-material/Check";
import { validate } from "../../../shared/utils/validation";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { Cross } from "../../../shared/assets/icons/index";
import CustomInput from "../../../shared/utils/Input";
import axios from "axios";
import Swal from "sweetalert2";
import "../../../shared/createForms/vendorOnboard.css";
import MinMaxFileUploader from "../../../shared/utils/minmaxFileUploader";
import { itiCoursesList } from "../../../shared/enums";
import GlobalDropdownField from "../../../shared/utils/GlobalDropdownField";
import GlobalInput from "../../../shared/utils/GlobalInput";
// Prevent mouse wheel from changing number inputs
const handleWheel = (e) => {
  e.target.blur(); // Remove focus to prevent wheel scroll
};

// Add event listener on focus
const handleFocus = (e) => {
  e.target.addEventListener("wheel", handleWheel, { passive: false });
};

// Remove event listener on blur
const handleBlur = (e) => {
  e.target.removeEventListener("wheel", handleWheel);
};

const ContractorAddEdit = ({
  isModalOpen,
  setIsModalOpen,
  selectedContractorData,
  setSelectedContractor,
  getAllContractors,
  setSnackbar,
}) => {
  const [formData, setFormData] = useState({
    name: selectedContractorData?.name || "",
    address: selectedContractorData?.address || "",
    phoneNumber: selectedContractorData?.phoneNumber || "",
    city: selectedContractorData?.city || "",
    state: selectedContractorData?.state || "",
    zipCode: selectedContractorData?.zipCode || "",
    bankDetails: {
      IFSC: selectedContractorData?.bankDetails?.IFSC || "",
      bankName: selectedContractorData?.bankDetails?.bankName || "",
      bankHolderName: selectedContractorData?.bankDetails?.bankHolderName || "",
      cancelledCheque:
        selectedContractorData?.bankDetails?.cancelledCheque || "",
      accountNumber: selectedContractorData?.bankDetails?.accountNumber || "",
      panNumber: selectedContractorData?.bankDetails?.panNumber || "",
    },
    // bankDetails: selectedContractorData?.bankDetails || {},
    aadhaarCardNumber: selectedContractorData?.aadhaarCardNumber || "",
    profilePic: selectedContractorData?.profilePic || "",
    addedBy: localStorage.getItem("userId"),
    updatedBy: localStorage.getItem("userId"),
  });
  useEffect(() => {
    if (selectedContractorData) {
      setFormData({
        name: selectedContractorData?.name || "",
        address: selectedContractorData?.address || "",
        phoneNumber: selectedContractorData?.phoneNumber || "",
        city: selectedContractorData?.city || "",
        state: selectedContractorData?.state || "",
        zipCode: selectedContractorData?.zipCode || "",
        bankDetails: {
          IFSC: selectedContractorData?.bankDetails?.IFSC || "",
          bankName: selectedContractorData?.bankDetails?.bankName || "",
          bankHolderName:
            selectedContractorData?.bankDetails?.bankHolderName || "",
          cancelledCheque:
            selectedContractorData?.bankDetails?.cancelledCheque || "",
          accountNumber:
            selectedContractorData?.bankDetails?.accountNumber || "",
          panNumber: selectedContractorData?.bankDetails?.panNumber || "",
        },
        aadhaarCardNumber: selectedContractorData?.aadhaarCardNumber || "",
        profilePic: selectedContractorData?.profilePic || "",
        addedBy: localStorage.getItem("userId"),
        updatedBy: localStorage.getItem("userId"),
      });
    }
  }, [selectedContractorData]);
  const [requiredFields, setRequiredFields] = useState({
    name: false,
    gender: false,
    address: false,
    phoneNumber: false,
    emailAddress: false,
    experience: false,
    state: false,
    city: false,
    zipCode: false,
  });

  // other
  // const [disableSaveButton, setDisableSaveButton] = useState();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;
  const serverURL = process.env.REACT_APP_URL;

  const today = new Date();
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  )
    .toISOString()
    .split("T")[0]; // Format the date in YYYY-MM-DD

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const nameParts = name.split(".");

      // Handle nested objects
      if (nameParts.length === 2) {
        const [objectName, key] = nameParts;
        return {
          ...prevFormData,
          [objectName]: {
            ...prevFormData[objectName],
            [key]: value,
          },
        };
      } else {
        // Clear city field if state changes
        if (name === "state") {
          return {
            ...prevFormData,
            [name]: value,
            city: "", // Clear the city field
          };
        }

        // Handle top-level fields normally
        return {
          ...prevFormData,
          [name]: value,
        };
      }
    });

    // Reset errors or perform validation here if needed
    setErrors((prevErrors) => ({
      ...prevErrors,
      city: "", // Clear errors for city field when state changes
    }));
  };

  const emptyInputCheck = (fieldName, value) => {
    if (value === "") {
      setRequiredFields({ ...requiredFields, [fieldName]: true });
    } else {
      setRequiredFields({ ...requiredFields, [fieldName]: false });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "State is required";

    if (!formData.aadhaarCardNumber)
      newErrors.aadhaarCardNumber = "Aadhaar Card is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";

    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.profilePic || formData.profilePic.length === 0) {
      newErrors.profilePic = "Profile photo is required";
    }
    if (!formData.zipCode) newErrors.zipCode = "Zip Code is required";

    if (!formData.phoneNumber || !/^\d{10}$/.test(formData.phoneNumber))
      newErrors.phoneNumber = "Phone Number is required";

    setErrors(newErrors);
    if (formData.zipCode && !/^\w{6}$/.test(formData.zipCode))
      newErrors.zipCode = "ZipCode is not valid";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedContractor({});
  };
  const [cityArray, setCityArray] = useState([]);

  useEffect(() => {
    const stateCode = statecityData.find(
      (ele) => ele.name === formData.state,
    )?.iso2;

    if (formData.state) {
      const fetchCities = async (stateCode) => {
        const headers = new Headers();
        headers.append("X-CSCAPI-KEY", cityApiKey);

        const requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
            requestOptions,
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const cityData = await response.json();
          setCityArray(cityData);

          // Log the city names
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      // Example usage: Fetch cities in Maharashtra (state code "MH")
      fetchCities(stateCode);
    }
  }, [formData.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: "Something Went Wrong in Validation",
        color: "black",
      });
    } else {
      try {
        if (selectedContractorData._id) {
          // Update existing vendor
          try {
            const installationPartnerSupervisorData = {
              ...formData,
            };
            setIsLoading(true);
            const response = await axios.put(
              `${serverURL}/installationPartnerSupervisor/edit/${selectedContractorData._id}`,
              installationPartnerSupervisorData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            );

            if (response.data.success) {
              setSnackbar({
                open: true,
                message: "Contractor Update Successfully",
                severity: "success",
              });
              setIsModalOpen(false);
              getAllContractors();
            } else {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "error",
                text: response.data.error,
                padding: "1em",
                color: "black",
              });
            }
          } catch (error) {
            console.error("Error updating Installation Partner:", error);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response.data.message,
              text: error.error,
              padding: "1em",
            });
          }
        } else {
          // Create new Contractor
          try {
            const updatedFormData = {
              ...formData,
              onboardedBy: "web",
            };

            setIsLoading(true);
            const response = await axios.post(
              `${serverURL}/installationPartnerSupervisor/create`,
              updatedFormData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            );
            if (response.data.success) {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });

              setIsModalOpen(false);
              getAllContractors();
            } else {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "error",
                text: response.data.error,
                padding: "1em",
                color: "black",
              }).then(() => {
                // setIsModalOpen(false);
                // getAllContractors();
              });
            }
          } catch (error) {
            console.error("Error creating Installation Partner:", error);
            setIsLoading(true);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response.data.message,
              text: `Error in creating Installation Partner !`,

              color: "black",
            });
          }
        }
      } catch (globalError) {
        setIsLoading(true);
        console.error("Unexpected error:", globalError);
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          title: "Oops...",
          text: "An unexpected error occurred!",
          padding: "1em",
          color: "red",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };
  const handleKeyPress = (e) => {
    const { name, type } = e.target;
    const charCode = e.keyCode || e.which;

    if (name === "userName") {
      if (/[^a-zA-Z\s]/.test(e.key)) {
        e.preventDefault();
      }
    } else if (type === "number" || name === "userPhoneNumber") {
      if ([69, 101, 43, 45, 46].includes(charCode)) {
        e.preventDefault();
      }
    }
  };

  return (
    <div>
      <Dialog open={isModalOpen} maxWidth="xl">
        <div
          className={`flex justify-between items-center ${Styles.vendorModalColor}`}
        >
          <DialogTitle>
            <span className="text-lg md:text-2xl font-bold">
              Contractor Form
            </span>
          </DialogTitle>
          <div
            onClick={handleClose}
            className="mx-5 my-4"
            style={{ cursor: "pointer" }}
          >
            <Cross />
          </div>
        </div>
        <DialogContent className={Styles.vendorModalColor}>
          <form onSubmit={handleSubmit}>
            <div className={Styles.formstyling}>
              <h4 className="mb-4 font-bold text-xl">Basic Details</h4>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="name"
                    placeholder="Enter Name"
                    title="Name *"
                    size="small"
                    required
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !value.startsWith(" ") &&
                        /^[A-Za-z\s]*$/.test(value)
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    // errorMessage={errors.name ? "Please Enter Name" : null}
                    error={errors.name}
                    value={formData?.name}
                  />
                  {errors.name && (
                    <div
                      className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]"
                      style={{ color: "var(--error-color) !important" }}
                    >
                      Please Enter Name
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="phoneNumber"
                    placeholder="Enter Phone Number"
                    title="Phone Number *"
                    type="number"
                    size="small"
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        // &&
                        // e.target.value.length < 11
                        handleInputChange(e);
                      }
                    }}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    value={formData?.phoneNumber}
                    error={errors.phoneNumber}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                  />
                  {errors.phoneNumber && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.phoneNumber}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="address"
                    placeholder="Enter Address"
                    title="Address *"
                    size="small"
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData?.address}
                    // errorMessage={
                    //   errors.address ? "Please Enter Your Address" : null
                    // }
                    error={errors.address}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                  />
                  {errors.address && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.address}
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="state"
                    label="State *"
                    value={formData?.state || ""}
                    onChange={(e) => {
                      handleInputChange({
                        target: {
                          name: "state",
                          value: e.target.value,
                        },
                      });
                    }}
                    placeholder="State"
                    options={
                      statecityData?.map((state) => ({
                        value: state.name,
                        label: state.name,
                      })) || []
                    }
                    variant="citySelect"
                    renderValueFn={(selected) => selected || "State"}
                    renderMenuItem={(opt) => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    )}
                    error={!!errors.state}
                    errorMessage={errors.state}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="city"
                    label="City *"
                    value={formData?.city || ""}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      })
                    }
                    placeholder="City"
                    options={
                      cityArray?.map((city) => ({
                        value: city.name,
                        label: city.name,
                      })) || []
                    }
                    variant="citySelect"
                    renderValueFn={(selected) => selected || "City"}
                    renderMenuItem={(opt) => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    )}
                    error={!!errors.city}
                    errorMessage={errors.city}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="zipCode"
                    placeholder="Enter Zip Code"
                    title="Zip Code *"
                    type="number"
                    size="small"
                    onKeyDown={(e) => {
                      // Prevent ArrowUp, ArrowDown, e, E, +, - keys
                      if (
                        ["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(
                          e.key,
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow empty values and validate zip code
                      if (value === "" || validate(value, "zipcode")) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    value={formData?.zipCode}
                    error={errors.zipCode}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()} // Prevent mouse wheel input
                    onKeyPress={(e) => {
                      // Prevent e, E, +, - characters
                      if (!validate(e.key, "numberInput")) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.zipCode && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.zipCode}
                    </p>
                  )}
                </Grid>
              </Grid>
            </div>

            <div className={`${Styles.formstyling} `}>
              <h4 className="mb-4 font-bold text-xl">Other Details</h4>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalInput
                    name="aadhaarCardNumber"
                    placeholder="Enter Aadhaar Card Number"
                    title="Aadhaar Card Number *"
                    size="large"
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 13
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    value={formData?.aadhaarCardNumber}
                    required
                    type="number"
                    error={errors.aadhaarCardNumber}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                    onKeyDown={(e) => {
                      // Prevent ArrowUp, ArrowDown, e, E, +, - keys
                      if (
                        ["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(
                          e.key,
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.aadhaarCardNumber && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      Please Enter Your Aadhaar Card Number
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <GlobalInput
                    name="bankDetails.bankName"
                    placeholder="Bank Name"
                    title="Bank Name"
                    size="large"
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !e.target.value.startsWith(" ") &&
                        /^[A-Za-z\s]*$/.test(value)
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.bankName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalInput
                    name="bankDetails.bankHolderName"
                    placeholder="Enter Name"
                    title="Bank Account Holder Name"
                    size="large"
                    maxLength={50}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !value.startsWith(" ") &&
                        /^[A-Za-z\s]*$/.test(value)
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.bankHolderName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalInput
                    name="bankDetails.accountNumber"
                    placeholder="Enter Account Number"
                    title="Bank Account Number"
                    type="number"
                    size="large"
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 17
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Prevent ArrowUp, ArrowDown, e, E, +, - keys
                      if (
                        ["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(
                          e.key,
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.bankDetails.accountNumber}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalInput
                    name="bankDetails.IFSC"
                    placeholder="Enter IFSC Code"
                    title="IFSC Code"
                    size="large"
                    maxLength={20}
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length <= 11
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.IFSC}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalInput
                    name="bankDetails.panNumber"
                    placeholder="Enter Pan Number"
                    title="Pan Number"
                    // type="number"
                    size="large"
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 11
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.panNumber}
                  />
                </Grid>
              </Grid>
            </div>
            <Grid container spacing={2} sx={{ marginTop: 0.5 }}>
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex ">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span
                        className={`${
                          errors.profilePic
                            ? "text-[var(--error-color)]"
                            : "text-gray-500 text-[20px] font-bold"
                        }`}
                      >
                        Profile Photo *
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.profilePic} // Prepopulate with profile photo
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            profilePic: urls, // Store the image as a Data URL for preview
                          })
                        }
                        typeOfFilesAllowed={"image/*"} // Specify allowed file types (only images)
                        maxFiles={1} // Limit to only 1 file
                      />
                      {errors.profilePic && (
                        <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left  mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                          {errors.profilePic}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span className="text-gray-500 text-[20px] font-bold">
                        Cancelled Cheque Photo
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData?.bankDetails?.cancelledCheque} // Prepopulate with cheque photo
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            bankDetails: {
                              ...formData.bankDetails,
                              cancelledCheque: urls,
                            },
                          })
                        } // Update formData with uploaded cheque photo
                        typeOfFilesAllowed={"image/*"} // Allow images
                        maxFiles={1} // Limit to only 1 file
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions>
          <div className="w-30">
            <GlobalButton
              variant="secondary"
              size="medium"
              onClick={handleClose}
            >
              {`Close`}
            </GlobalButton>
          </div>
          <div className="w-30">
            <GlobalButton
              variant="primary"
              size="medium"
              type="submit"
              isLoading={isLoading}
              disabled={isLoading}
              // disabled={disableSaveButton}
              onClick={(e) => {
                // setIsLoading(true)
                setSaveButtonClicked(true);
                handleSubmit(e);
              }}
            >
              {selectedContractorData._id ? "UPDATE" : "SAVE"}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ContractorAddEdit;
